export const getProfileIdsFromParams = ((params) =>
{
  let profileIds = [];
  if (params.profileId)
  {
    profileIds.push(params.profileId);
  }
  if (params.secondProfileId)
  {
    profileIds.push(params.secondProfileId);
  }
  return profileIds;
});

export const getClubIdFromParams = ((params) =>
{
  if (params.clubId)
  {
    return params.clubId;
  }
  return false;
});
export const updateUrl = (baseUrl, params, replace = false) =>
{
  const newUrl = baseUrl + `/${params.join('/')}`;
  if (replace)
  {
    window.history.replaceState({}, '', newUrl);
  } else
  {
    window.history.pushState({}, '', newUrl);
  }
}